import { BASE_URL } from '@core/api/constants';

export const getURL = (url: string) => `${BASE_URL}/${url}`;
